var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"maps"}},[_c('map-container',{attrs:{"zoom":_vm.zoom,"center":_vm.center,"drawMenu":_vm.drawMenu,"layers":_vm.layers,"initialConfig":_vm.initialConfig},on:{"mapSelections":_vm.addParamMapSelections}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }